export const enum ErrorName {
  BROWSER_ERROR = "BROWSER_ERROR",
  CACHE_EXPIRED = "CACHE_EXPIRED",
  CACHE_MISMATCH = "CACHE_MISMATCH",
  FILE_NOT_FOUND = "FILE_NOT_FOUND",
  FILE_NOT_PDF = "FILE_NOT_PDF",
  GENERIC_ERROR = "GENERIC_ERROR",
}
